// src/api/customReport.js
import apiClient from '../utils/apiClient';

const base = '/CustomReports';

export const GetAllCustomReports = async () => {
  try {
    const response = await apiClient.get(`${base}/GetAll`);
    return response.data;
  } catch (error) {
    console.error('Error fetching custom reports:', error);
    return Promise.reject(error);
  }
};

export const GetTemplatesInfo = async () => {
  try {
    const response = await apiClient.get(`${base}/GetTemplates`);
    return response.data;
  } catch (error) {
    console.error('Error fetching templates:', error);
    return Promise.reject(error);
  }
};

// Backend'de eksikse bu endpointin C# tarafı eklenmeli.
export const GetTemplateColumns = async templateId => {
  try {
    const response = await apiClient.get(
      `${base}/Templates/${templateId}/Columns`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching template columns:', error);
    return Promise.reject(error);
  }
};

export const GetCustomReportById = async id => {
  try {
    const response = await apiClient.get(`${base}/GetById`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching report with ID ${id}:`, error);
    return Promise.reject(error);
  }
};

export const CreateCustomReport = async payload => {
  try {
    const response = await apiClient.post('/CustomReports', payload);

    return response.data;
  } catch (error) {
    console.error('Error creating report:', error);
    return Promise.reject(error);
  }
};

export const UpdateCustomReport = async (id, data) => {
  try {
    const response = await apiClient.put(`${base}`, data, {
      params: { Id: id },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating report:', error);
    return Promise.reject(error);
  }
};

export const DeleteCustomReport = async id => {
  try {
    const response = await apiClient.delete(`${base}`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting report:', error);
    return Promise.reject(error);
  }
};

export const GenerateCustomReportFile = async id => {
  try {
    const response = await apiClient.get(`${base}/${id}/generate`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `custom_report_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error generating report file:', error);
    return Promise.reject(error);
  }
};

// Opsiyonel: Preview indirme (HTML->PDF)
export const DownloadTemplatePreview = async templateId => {
  try {
    const response = await apiClient.get(
      `${base}/Templates/${templateId}/download`,
      {
        responseType: 'blob',
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `template_${templateId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error downloading template preview:', error);
    return Promise.reject(error);
  }
};
